/* istanbul ignore file */
import { useEffect, useState } from 'react';
import {
  BREAKPOINT_MOBILE_MAX,
  BREAKPOINT_TABLET_MAX,
  BREAKPOINT_TABLET_MIN,
} from './constants';

export type ChooDeviceBreakpoints = 'mobile' | 'tablet' | 'desktop';

export interface UseDeviceWidthOptions {
  tablet?: boolean;
}

/**
 * a hook to help you find out if the current device is mobile or desktop. Can also
 * be configured to handle tablet sizes if the tablet option is set to true.
 */
function useDeviceWidth({
  tablet = false,
}: UseDeviceWidthOptions = {}): ChooDeviceBreakpoints {
  const [deviceView, setDeviceView] = useState<ChooDeviceBreakpoints>('mobile'); // mobile is the default view

  useEffect(() => {
    let mobileQl: MediaQueryList;
    let tabletQl: MediaQueryList;

    function handleChangeEvent() {
      let device: ChooDeviceBreakpoints;
      if (mobileQl.matches) {
        device = 'mobile';
      } else if (tablet && tabletQl.matches) {
        device = 'tablet';
      } else {
        device = 'desktop';
      }
      setDeviceView(device);
    }

    mobileQl = window.matchMedia(`(max-width: ${BREAKPOINT_MOBILE_MAX}px)`);
    tabletQl = window.matchMedia(
      `(min-width: ${BREAKPOINT_TABLET_MIN}) and (max-width: ${BREAKPOINT_TABLET_MAX}px)`
    );

    mobileQl.addEventListener('change', handleChangeEvent);
    tabletQl.addEventListener('change', handleChangeEvent);

    handleChangeEvent();

    return () => {
      mobileQl.removeEventListener('change', handleChangeEvent);
      tabletQl.removeEventListener('change', handleChangeEvent);
    };
  }, [
    setDeviceView,
    BREAKPOINT_MOBILE_MAX,
    BREAKPOINT_TABLET_MIN,
    BREAKPOINT_TABLET_MAX,
  ]);

  return deviceView;
}

export default useDeviceWidth;
